import React, { FC } from 'react'
import { useSearchContext } from '../SearchContext'
import MobileSearchResultsMenu from './MobileSearchResultsMenu'
import DesktopSearchResultsMenu from './DesktopSearchResultsMenu'
import { useResponsive } from '@src/utils/useResponsiveSizes'

const SearchResultsMenu: FC = () => {
  const { metadata } = useSearchContext()
  const { isMobile } = useResponsive()
  if (!metadata?.itemCount && !metadata?.count) return null
  return (
    <>
      {/* Keeping Separate Component Between Mobile and Desktop for Better Organization */}
      {isMobile ? <MobileSearchResultsMenu /> : <DesktopSearchResultsMenu />}
    </>
  )
}

export default SearchResultsMenu
